<template>
  <div class="food-flx">
    <div class="food-flx-item">
      <img src="@assets/img/home/food_icon.png" alt="">
      <p>{{ num | formatNumber }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({
        columns: [],
        rows: []
      })
    }
  },
  computed: {
    num() {
      const [dimensionKey, indicatrixKey] = this.data.columns;
      return this.data.rows.reduce((pre, crt) => {
        pre += crt[indicatrixKey];
        return pre;
      }, 0);
    }
  }
};
</script>

<style lang="scss" scoped>
.food-flx {
  text-align: center;
  &-item {
    padding-top: 50px;
    img {
      width: 160px;
      height: 160px;
    }
    p {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 250px;
      height: 60px;
      font-size: 30px;
      font-weight: 600;
      color: #444444;
      background: #F7F7F9;
      margin: 0 auto;
       margin-top: 20px;
    }
  }
}
</style>
